export default "__VITE_ASSET__AgaX85Iw__"